import { Fragment } from "react";
import "./index.css";
function HelpParisPage() {
  return (
    <div className="content-help-paris">
      <div className="help-paris-page">
        <div className="content mb-0">
          <img className="mb-2" src="assets/img/paris/android/logo.svg" alt="" />
          <img src="assets/img/paris/android/txt.svg" alt="" />
          <img className="mv-2" src="assets/img/paris/2.svg" alt="" />
          <a
            href="https://drive.google.com/file/d/1x3SnCDsykJ9fXs6UTAkTt3D59N44u8h-/view?usp=drive_link"
            target="_blank"
            rel="noreferrer"
          >
            <img className="card" src="assets/img/paris/3.svg" alt="" />
          </a>
          <a
            href="https://drive.google.com/file/d/1HzYjV1EqXxmG8aZN9EYM_kTu98nyVADh/view?usp=drive_link"
            target="_blank"
            rel="noreferrer"
          >
            <img className="card" src="assets/img/paris/4.svg" alt="" />
          </a>
          <a
            href="https://drive.google.com/file/d/1d1mcZU3ZNLi8WprZIhQa6G-A6DQfT4l1/view?usp=drive_link"
            target="_blank"
            rel="noreferrer"
          >
            <img className="card" src="assets/img/paris/5.svg" alt="" />
          </a>
          <a
            href="https://drive.google.com/file/d/1LWKQQ8cS5eAnGrxECtoMKKhGBYoWac05/view?usp=drive_link"
            target="_blank"
            rel="noreferrer"
          >
            <img className="card" src="assets/img/paris/66.svg" alt=""/>
          </a>
          <a
            href="https://drive.google.com/file/d/19BbTgs9iflFIOvflbEvC_Zo9LKdndZ3q/view?usp=drive_link"
            target="_blank"
            rel="noreferrer"
          >
            <img className="card" src="assets/img/paris/8.svg" alt="" />
          </a> 
{/*           <a
            href="https://drive.google.com/file/d/1a0JQxnhk-mk99bAyZyKGnik6rP5f5SWD/view?usp=drive_link"
            target="_blank"
            rel="noreferrer"
          >
            <img className="card" src="assets/img/paris/77.svg" alt="" />
          </a>  */}
          <img className="mv-6" src="assets/img/paris/6.svg" alt="" />
          <img src="assets/img/paris/7.svg" alt="" />
        </div>
      </div>
    </div>
  );
}

export default HelpParisPage;
